import React from 'react';
import { Add } from '@material-ui/icons';
import { useTranslation } from '@michelin/central-provider';
import { SpeedDialActions } from 'components/SpeedDial';
import { SelectedServiceOffer, ServiceOfferIds, getBaseUrl, getSelectedServiceOffer } from 'prefs-and-service-offers';
import { useHistory } from 'react-router-dom';

export enum ServiceParams {
  MECHANICAL = 'mechanical',
  TIRE_WHEEL = 'tire-wheel',
}
export enum ProfileParams {
  ONSITE = 'onsite',
  ERS = 'ers',
  ERS_ONSITE = 'ers-onsite',
}

const useGetViewActions = () => {
  let actions: SpeedDialActions[] = [];
  const { t } = useTranslation();
  const history = useHistory();

  const selectedServiceOffer: SelectedServiceOffer | undefined = getSelectedServiceOffer() || undefined;
  const onCallFlag: boolean =
    !!selectedServiceOffer && !!selectedServiceOffer.id && selectedServiceOffer.id === ServiceOfferIds.onCall;
  const fleetOrderFlag: boolean =
    !!selectedServiceOffer && !!selectedServiceOffer.id && selectedServiceOffer.id === ServiceOfferIds.bulkOrder;

  actions.push({
    icon: <Add />,
    title: t('Tires and Wheels - Onsite'),
    name: 'Tires and Wheels - Onsite',
    id: 'tires-and-wheels-onsite',
    onClick: () => {
      history.push(`${getBaseUrl()}/billing/${ServiceParams.TIRE_WHEEL}/${ProfileParams.ONSITE}/create`);
    },
    titleOpen: true,
  });
  actions.push({
    icon: <Add />,
    title: t('Tires and Wheels - ERS'),
    name: 'Tires and Wheels - ERS',
    id: 'tires-and-wheels-ers',
    onClick: () => {
      history.push(`${getBaseUrl()}/billing/${ServiceParams.TIRE_WHEEL}/${ProfileParams.ERS}/create`);
    },
    titleOpen: true,
  });
  actions.push({
    icon: <Add />,
    title: t('Tires and Wheels - ERS & Onsite'),
    name: 'Tires and Wheels - ERS & Onsite',
    id: 'tires-and-wheels-ers-onsite',
    onClick: () => {
      history.push(`${getBaseUrl()}/billing/${ServiceParams.TIRE_WHEEL}/${ProfileParams.ERS_ONSITE}/create`);
    },
    titleOpen: true,
  });
  actions.push({
    icon: <Add />,
    title: t('Mechanical - Onsite'),
    name: 'Mechanical - Onsite',
    id: 'mechanical-onsite',
    onClick: () => {
      history.push(`${getBaseUrl()}/billing/${ServiceParams.MECHANICAL}/${ProfileParams.ONSITE}/create`);
    },
    titleOpen: true,
  });
  actions.push({
    icon: <Add />,
    title: t('Mechanical - ERS'),
    name: 'Mechanical - ERS',
    id: 'mechanical-ers',
    onClick: () => {
      history.push(`${getBaseUrl()}/billing/${ServiceParams.MECHANICAL}/${ProfileParams.ERS}/create`);
    },
    titleOpen: true,
  });
  actions.push({
    icon: <Add />,
    title: t('Mechanical - ERS & Onsite'),
    name: 'Mechanical - ERS & Onsite',
    id: 'mechanical-ers-onsite',
    onClick: () => {
      history.push(`${getBaseUrl()}/billing/${ServiceParams.MECHANICAL}/${ProfileParams.ERS_ONSITE}/create`);
    },
    titleOpen: true,
  });

  if (onCallFlag) {
    actions = actions.filter((action) => action.id !== 'mechanical-onsite' && action.id !== 'tires-and-wheels-onsite');
  }
  if (fleetOrderFlag) {
    actions = actions.filter((action) => action.id !== 'mechanical-ers' && action.id !== 'tires-and-wheels-ers');
  }
  return actions;
};

export { useGetViewActions };
